import { Box, type BoxProps } from '@chakra-ui/react';
import React from 'react';

const ContentHeader: React.FC<BoxProps> = ({ children, ...props }) => {
  return (
    <Box
      px={4}
      py={3}
      h="60px"
      display="flex"
      alignItems="center"
      borderBottom="1px solid"
      borderColor="gray.100"
      bg="white/88"
      backdropFilter="blur(10px)"
      flexShrink={0}
      {...props}
    >
      {children}
    </Box>
  );
};

export default ContentHeader;
